<template>
  <section>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●大般涅槃經</h3>
        <h4> （北涼）天竺三藏曇無讖譯</h4>
        <p>能隨問答者。若有人來問佛世尊。我當云何不捨錢財。而得名為大施檀越。
佛言。若有沙門婆羅門等。少欲知足不受不畜不淨物者。當施其人奴婢僕使。修梵行者施與女人斷酒肉者施以酒肉。不過中食施過中食。不著花香施以花香。如是施者施名流布。遍至他方。財寶之費不失毫釐。是則名為能隨問答。</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●央掘摩羅彌殺彌慈論</h3>
        <h4> （北涼）天竺三藏曇無讖譯</h4>
        <p>央掘摩羅——此云指鬘；又名一切世間現。生於佛世，印度舍衛城北，薩那村人也。受學於婆羅門，師事摩尼跋陀羅。因被師婦之讒，迫乎師命，昧乎道理，信殺千人有涅槃可證，不怕萬劫受泥犁之苦。殺一七多日，惡實彌深，傷九百餘命，心何殘忍！佛悲愍之，放光照他，為之說法，立時改過懺悔，受持佛戒；當下迴光返照，發現良知，得四聖果，具六神通。所謂屠刀放下，立地成佛；苦海無邊，回頭是岸。如是改惡皈佛，固屬善矣！唯彌殺彌慈之謂，似乎不當？夫殺者，惡也，慈者，善也，非彌殺彌惡乎？蓋善惡之不相扶，猶冰炭之不相容然，於理寧無違乎？何天台大師舉斯言耶？想必有其宗旨在焉。</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●藥師琉璃光本願功德經</h3>
        <p>「放諸生命…病得除愈，眾難解脫。」「放生修福…令度苦厄，不遭眾難。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●契經</h3>
        <p>「戒殺放生，得長壽報，又戒殺放生，可解怨釋結，長養悲心，潤菩提種。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●華嚴經普賢行願品</h3>
        <p>「眾生至愛者身命，諸佛至愛者眾生，能救眾生身命，則能成就諸佛心願。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●梵網經菩薩戒</h3>
        <h4>‧殺戒：</h4>
        <p>「佛子！若自殺、教人殺、方便殺、讚歎殺，見作隨喜，乃至咒殺。殺因、殺緣、殺法、殺業。乃至一切有命者，不得故殺。是菩薩應起常住慈悲心、孝順心，方便救護一切眾生，而反恣心快意殺生者，是菩薩婆羅夷罪。」</p>
        <h4>‧不行放救戒：</h4>
        <p>「若佛子！以慈心故，行放生業，一切男子是我父，一切女人是我母，我生生無不從之受生，故六道眾生皆是我父母，而殺而食者，即殺我父母，亦殺我故身，一切地水是我先身，一切火風是我本體，故常行放生，生生受生，常住之法，教人放生。若見世人殺畜生時，應方便救護，解其苦難。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●正法念經</h3>
        <p>「造一所寺，不如救一人命。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●分別善惡報應經</h3>
        <p>「何業獲報長命？有十種業。何等為十？一、離自無殺，二、離勸他殺，三、離慶快殺，四、離隨喜殺，五，救刑獄殺，六，放生命，七、施他無畏，八、慈恤病人，九、惠施飲食，十、幡燈供養。如是十種獲長命報。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●佛滅度後棺歛葬送經</h3>
        <p>「當遵慈仁。普惠恩及群生，視天下群生身命，若己身命，慈濟悲愍，恕己安彼，道喜開化，護彼若身，潤逮草木，無虛機絕也。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●大智度論</h3>
        <p>「諸餘罪中，殺業最重。 諸功德中，放生第一。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●彌勒菩薩偈</h3>
        <p>「勸君勤放生，終久得長壽，若發菩提心，大難天須救。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●大佛頂首楞嚴經</h3>
        <h4>唐天竺沙門般剌密帝譯／烏萇國沙門彌伽釋迦譯語</h4>
        <p>「以人食羊，羊死為人，如是乃至十生之類，死死生生，互來相噉，惡業俱生，窮未來際，以是因緣，經千百劫，常在生死。」又云：「汝等當知，是食肉人縱得心開似三摩地，皆大羅剎，報終必沈生死苦海，非佛弟子。如是之人，相殺相吞，相食未已；云何是人得出三界？」</p>
        <p>「阿難！又諸世界六道眾生，其心不殺，則不隨其生死相續。汝修三昧，本出塵勞，殺心不除，塵不可出。縱有多智，禪定現前，如不斷殺，必落神道。上品之人，為大力鬼；中品則為飛行夜叉，諸鬼帥等；下品當為地行羅剎。彼諸鬼神，亦有徒眾，各各自謂，成無上道。我滅度後，末法之中，多此鬼神，熾盛世間，自言食肉得菩提路。阿難！我令比丘食五淨肉，此肉皆我神力化生，本無命根。汝婆羅門，地多蒸濕，加以沙石，草菜不生。我以大悲，神力所加，因大慈悲，假名為肉，汝得其味。奈何如來滅度之後，食眾生肉，名為釋子。汝等當知！是食肉人，縱得心開，似三摩地，皆大羅剎，報終必沈生死苦海，非佛弟子。如是之人，相殺相吞，相食未已，云何是人得出三界？汝教世人修三摩地，次斷殺生，是名如來先佛世尊第二決定清淨明誨。是故阿難！若不斷殺，修禪定者，譬如有人自塞其耳，高聲大叫，求人不聞，此等名為欲隱彌露。清淨比丘，及諸菩薩，於歧路行，不蹋生草，況以手拔。云何大悲，取諸眾生血肉充食？」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●大乘入楞伽經</h3>
        <p>「大慧菩薩白佛言：「世尊！願為我說食不食肉功德過失，我及諸菩薩摩訶薩知其義已，為未來、現在報習所熏食肉眾生而演說之，令捨肉味，求於法味，於一切眾生起大慈心，更相親愛，如一子想，住菩薩地，得阿耨多羅三藐三菩提。」佛告大慧：「一切諸肉，有無量緣，菩薩於中，當生悲愍，不應啖食。我今為汝說其少分。大慧！一切眾生從無始來，在生死中，輪迴不息，靡不曾作父母兄弟男女眷屬，乃至朋友親愛侍使，易生而受鳥獸等身，云何於中取之而食！大慧！菩薩摩訶薩觀諸眾生，同於己身，念肉皆從有命中來，云何而食！大慧！諸羅剎等，聞我此說，尚應斷肉，況樂法人。大慧！菩薩摩訶薩觀諸眾生，皆是親屬，乃至慈念如一子想，是故不應食一切肉。大慧！食肉之人，眾生見之，悉皆驚怖，修慈心者，云何食肉。大慧！夫食肉者，身體臭穢，賢聖善人不用親狎，是故菩薩不應食肉。大慧！夫血肉者，眾仙所棄，群聖不食，是故菩薩不應食肉。大慧！若我弟子食啖於肉，令諸世人悉懷譏謗，而作於言，云何沙門修淨行人，猶如惡獸，食肉滿腹，游行世間，令諸眾生，悉懷驚怖，壞清淨行，失沙門道。菩薩慈愍，為護眾生，不令生於如是之心，不應食肉。大慧！諸善男女，寂靜修行。或住慈心，或持咒術，或求解脫，或趨大乘，以食肉故，一切障礙，不得成就。是故菩薩欲自利利他，不應食肉。菩薩慈念一切眾生，猶如己身，云何見之而作食意！是故菩薩不應食肉。大慧！夫食肉者，諸天遠離，口氣常臭，增長疾病，易生瘡癬。大慧！肉非美好，肉不清淨，生諸罪惡，敗諸功德，諸仙聖人之所棄捨，云何而許弟子食肉耶？若言許食，此人謗我！大慧！夫食肉者，有如是等無量過失，斷而不食，獲大功德。凡愚不知如是損益，是故我今為汝開演：凡是肉者，悉不應食。」</p>
        <p>「爾時，大慧菩薩以偈問曰：『 彼諸菩薩等，志求佛道者， 酒肉及與蔥，飲食為云何？ 惟願無上尊，哀愍為演說。 愚夫所貪著，臭穢無名稱， 虎狼所甘嗜，云何而可食？ 食者生諸過，不食為福善， 惟願為我說，食不食罪福。』
　　大慧菩薩說偈問已，復白佛言：「惟願世尊，為我等說食不食肉功德過惡。我及諸菩薩於現在未來，當為種種希望食肉眾生，分別說法，令彼眾生慈心相向。得慈心已，各於住地清淨明了，疾得究竟無上菩提。聲聞緣覺自地止息已，亦得速成無上菩提。惡邪論法，諸外道輩，邪見斷常，顛倒計著，尚有遮法，不聽食肉。況復如來，世間救護，正法成就，而食肉耶？」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●一切智光明仙人慈心因緣不食肉經</h3>
        <h3>譯者失佚，附秦錄</h3>
        <p>如是我聞：一時，佛住摩伽提國寂滅道場彌加女村自在天祠精舍。時有迦波利婆羅門子，名彌勒，軀體金色，三十二相，八十種好，放銀光明，黃金校飾，如白銀山，威光無量，來至佛所。爾時，世尊與千二百五十比丘經行林中，又有結髮梵志五百人等，遙見彌勒威儀庠序，相好清淨，五體投地如銀山崩，成金花聚寶間廁，金花金臺，七寶為閣，於臺閣中，有妙音聲而說偈言：</p>
        <p>
我見牟尼尊 面貌常清淨
百福相奇特 世間無倫匹
煩惱垢永盡 智慧悉成滿
一向常歸命 身心無疲倦
故我以五體 欲得勝安樂
脫苦無所畏 敬禮釋迦文
        </p>
        <p>時，諸梵志見聞此事，白佛言：「世尊！如此童子威儀庠序，光明無量，與佛無異，於何佛所初發道心？受持誰經？唯願天尊為我解說。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●一切智光明仙人慈心因緣不食肉經</h3>
        <h3>譯者失佚，附秦錄</h3>
        <p>如是我聞：一時，佛住摩伽提國寂滅道場彌加女村自在天祠精舍。時有迦波利婆羅門子，名彌勒，軀體金色，三十二相，八十種好，放銀光明，黃金校飾，如白銀山，威光無量，來至佛所。爾時，世尊與千二百五十比丘經行林中，又有結髮梵志五百人等，遙見彌勒威儀庠序，相好清淨，五體投地如銀山崩，成金花聚寶間廁，金花金臺，七寶為閣，於臺閣中，有妙音聲而說偈言：</p>
        <p>
我見牟尼尊 面貌常清淨
百福相奇特 世間無倫匹
煩惱垢永盡 智慧悉成滿
一向常歸命 身心無疲倦
故我以五體 欲得勝安樂
脫苦無所畏 敬禮釋迦文
        </p>
        <p>時，諸梵志見聞此事，白佛言：「世尊！如此童子威儀庠序，光明無量，與佛無異，於何佛所初發道心？受持誰經？唯願天尊為我解說。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●佛說業報差別經得長命報之法</h3>
        <h4>隋洋川郡守瞿曇法智譯</h4>
        <p>佛告首迦：「一切眾生，繫屬於業，依止於業，隨自業轉，以是因緣，有上中下差別不同......復有十業，能令眾生得長命報，何等為十業？一者、自不殺生。二者、勸他不殺。三者、讚嘆不殺。四者、見他不殺，心生歡喜。五者、見彼殺者，方便救免。六者、見死怖者，安慰其心。七者、見恐怖者，施與無畏。八者、見諸患苦，起慈愍心。九者、見諸急難，起大悲心。十者、以諸飲食，惠施眾生。以是十業，得長命報。」</p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <h3>●佛說十善業道經：不殺生利益</h3>
        <h4>唐于闐三藏沙門實叉難陀譯</h4>
        <p>爾時世尊告龍王言：「一切眾生，心想異故，造業亦異，由是故有諸趣輪轉......龍王！若離殺生，即得成就十離惱法，何等為十？一、於諸眾生普施無畏。二、常於眾生起大慈心。三、永斷一切瞋恚習氣。四、身常無病。五、壽命長遠。六、恆為非人之所守護。七、常無惡夢，寢覺快樂。八、滅除怨結，眾怨自解。九、無惡道怖。十、命終生天。是為十。」</p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "sutra",
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    //alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>